export class ShortCodeAlreadyExistsException extends Error {
  constructor(message) {
    super(message);
  }
}

